<!--
  --
  -- 組織ページのフッタ コンポーネント
  --
  -->
<template>
  <v-footer
    class="flex-column"
    :dark="dark" color="footer"
  >
    <c-nav
      v-if="links.length > 0"
      class="mb-2"
      :links="links"
    />
    <c-credit />
  </v-footer>
</template>

<script>
import CNav from './CNav'
import CCredit from './CCredit'

export default {
  name: 'CFooter',
  components: {
    CNav,
    CCredit
  },
  computed: {
    dark () {
      return this.isDarkColor('footer')
    },

    links () {
      return this.getters['org/links']
    }
  }
}
</script>
